import React from "react";
import { CaretLeft, CaretRight, CaretDown } from "@phosphor-icons/react";

export default function RoundSelector({ rounds, activeId, onChange }) {
  const idx = rounds.findIndex((r) => r.round_id === activeId);
  const active = rounds[idx];
  const [open, setOpen] = React.useState(false);

  if (!active) return null;

  const go = (delta) => {
    const next = rounds[idx + delta];
    if (next) onChange(next.round_id);
  };

  return (
    <div className="relative my-5 flex items-center gap-2 justify-center" data-testid="round-selector">
      <button
        type="button"
        data-testid="round-prev"
        onClick={() => go(-1)}
        disabled={idx <= 0}
        className="w-10 h-10 rounded-full border border-neutral-200 bg-white flex items-center justify-center text-[#41a42b] disabled:text-neutral-300 disabled:border-neutral-100 active:scale-95 transition-all"
      >
        <CaretLeft size={18} weight="bold" />
      </button>
      <button
        type="button"
        data-testid="round-toggle"
        onClick={() => setOpen((o) => !o)}
        className="flex-1 max-w-[240px] flex items-center justify-between gap-2 px-4 py-2.5 bg-white border border-neutral-200 rounded-full shadow-sm"
      >
        <div className="flex flex-col items-start leading-tight">
          <span className="text-[9px] font-bold tracking-[0.2em] uppercase text-neutral-400">{active.name.split("—")[1]?.trim() || active.name}</span>
          <span className="font-display text-sm text-[#02371b]">{active.date_range}</span>
        </div>
        <CaretDown size={14} weight="bold" className={`text-neutral-500 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      <button
        type="button"
        data-testid="round-next"
        onClick={() => go(1)}
        disabled={idx >= rounds.length - 1}
        className="w-10 h-10 rounded-full border border-neutral-200 bg-white flex items-center justify-center text-[#41a42b] disabled:text-neutral-300 disabled:border-neutral-100 active:scale-95 transition-all"
      >
        <CaretRight size={18} weight="bold" />
      </button>

      {open && (
        <div
          className="absolute left-1/2 -translate-x-1/2 top-full mt-2 w-[280px] bg-white border border-neutral-200 rounded-2xl shadow-xl z-30 overflow-hidden"
          data-testid="round-dropdown"
        >
          {rounds.map((r) => (
            <button
              key={r.round_id}
              type="button"
              data-testid={`round-option-${r.round_id}`}
              onClick={() => { onChange(r.round_id); setOpen(false); }}
              className={`w-full text-left px-4 py-3 hover:bg-neutral-50 border-b border-neutral-100 last:border-0 ${r.round_id === activeId ? "text-[#41a42b]" : "text-[#02371b]"}`}
            >
              <div className="flex items-baseline justify-between gap-2">
                <span className="font-display text-sm">{r.date_range}</span>
                <span className="text-[10px] font-mono-tab text-neutral-400">{r.name.split("—")[1]?.trim() || r.name}</span>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
